export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 p-8 md:p-12 lg:p-14 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap w-fit">
                商务合作
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md">
                如果你有影视资源合作、广告投放、内容推荐或其他业务需求，欢迎通过以下方式与我们取得联系。我们将在一个工作日内回复。
              </p>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-400">合作邮箱</div>
                    <div className="text-sm font-medium text-foreground-800">contact@kukecinema.com</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                    <i className="ri-chat-3-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-400">在线反馈</div>
                    <div className="text-sm font-medium text-foreground-800">网站底部留言板</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-[420px] bg-gradient-to-br from-primary-500/8 via-accent-500/5 to-background-100 flex items-center justify-center p-8 md:p-12">
              <div className="text-center">
                <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/10 mb-4">
                  <i className="ri-service-line text-3xl text-primary-600"></i>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  期待与优秀的创作者、<br />版权方和品牌伙伴合作
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}